module.exports = __webpack_public_path__ + "img/apartment.bd9a61ea.svg";